import { SelectionModel } from '@angular/cdk/collections';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

import jsPDF from 'jspdf';
import autoTable, { RowInput } from 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { TypeOperationEnum } from 'src/app/core/enums/type-operation.enum';
import { DesaparecidoGamService } from 'src/app/core/services/gam/desaparecido-gam.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { DesaparecidoGamVo } from 'src/app/shared/models/gam/desaparecido-gam-vo.model';
import { PublicadoViewComponent } from '../publicacion-view/publicado-view.component';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { PublicadoFormComponent } from 'src/app/modules/caso/monitor/publicado-form/publicado-form.component';
import { PublicacionService } from 'src/app/core/services/caso/publicacion.service';

@Component({
  selector: 'vex-desaparecido-gam-list',
  templateUrl: './desaparecido-gam-list.component.html',
  styleUrls: ['./desaparecido-gam-list.component.scss']
})
export class DesaparecidoGamListComponent implements OnInit {

  appSettings = AppSettings;
  stateConstant = StateConstant;

  dataSource: MatTableDataSource<DesaparecidoGamVo>;
  displayedColumns: string[] = ['apellido_paterno', 'apellido_materno', 'nombres', 'documento', 'nacionalidad', 'edad', 'departamento', 'encontrado', 'fechaDesaparicion', 'actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selection = new SelectionModel<DesaparecidoGamVo>(true, []);
  searchKey: string;

  desaparecidoService = inject(DesaparecidoGamService);
  publicacionService = inject(PublicacionService);

  desaparecidos: DesaparecidoGamVo[];

  crumbs: AppRooute[] = [RouteConstant.ROUTE_GAM_DESAPARECIDOS];
  reportData: RowInput = [];

  formSearch: FormGroup;

  constructor(private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.desaparecidoService.findAll().subscribe(
      response => {
        this.desaparecidos = response.data
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      err => {
        console.error(err);
      }
    )
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  create() {
    this.router.navigate([`./${RouteConstant.ROUTE_GAM_DESAPARECIDOS.url}/${TypeOperationEnum.CREATE}`]);
  }
  detail(vo: DesaparecidoGamVo) {
    this.router.navigate([`./${RouteConstant.ROUTE_GAM_DESAPARECIDOS.url}/${TypeOperationEnum.UPDATE}/${vo.id}`]);
  }

  delete(id: number) {
    const dialogData = new ConfirmDialogModel("Eliminar", "¿Esta seguro de eliminar el registro selecionado?");
    this.dialog
      .open(ConfirmDialogComponent, {
        data: dialogData
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.desaparecidoService.delete(id).subscribe(
            response => {
              if (response.status) {
                this.toastrService.success(response.message);
                this.loadList();
              } else {
                this.toastrService.warning(response.message);
              }
            },
            err => {
              this.toastrService.error(err.data);
            }
          )
        }
      });
  }

  downloadPdf() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    doc.addFont('assets/fonts/PTSans.ttf', 'PTSans', 'normal');
    let bodyData: any[] = [];
    this.desaparecidos.forEach(function (desaparecido) {
      bodyData.push([desaparecido.nombreCompleto, desaparecido.documento, desaparecido.edad, desaparecido.departamento, desaparecido.encontrado, desaparecido.nacionalidad, desaparecido.fechaDesaparicion]);
    });
    autoTable(doc, {
      head: [['Nombre completo', 'Documento', 'Edad', 'Departamento', 'Encontrado', 'Nacionalidad', 'Fecha desaparecido']],
      body: bodyData,
      styles: {
        fontSize: 6
      }
    })
    doc.save('desaparecidos-gam.pdf')
  }

  afiche(vo: DesaparecidoGamVo) {
    //console.log(vo);
    const dialogRef = this.dialog.open(PublicadoViewComponent, {
      width: "800px",//AppSettings.DIALOG_WIDTH,
      data: {
        operation: "OperacionEnum.config",
        title: 'Ver afiche',
        button: AppSettings.DIALOG_BUTTON_UPDATE_POSITIVE,
        entity: vo
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //this.loadList();
      }
    });
  }

  /*cambiarEstado(id: number) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: new ConfirmDialogModel("Cambiar publicado", "¿Está seguro de cambiar el estado de publicado?")
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.publicacionService.cambiarPublicado(id).subscribe(
            response => {
              if (response.status) {
                this.toastrService.success(response.message);
                this.loadList();
              } else {
                this.toastrService.warning(response.message);
              }
            },
            err => {
              this.toastrService.error(err.data);
            }
          )
        }
      });
  }*/

  conf(vo: DesaparecidoGamVo) {
    //console.log(vo);
    const dialogRef = this.dialog.open(PublicadoFormComponent, {
      width: AppSettings.DIALOG_WIDTH,
      data: {
        operation: OperacionEnum.config,
        title: 'Configuración',
        button: AppSettings.DIALOG_BUTTON_UPDATE_POSITIVE,
        entity: vo
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadList();
      }
    });
  }
}
